import { FC } from 'react';

import {
  LoadingLayoutWrapper,
  VerificationCodeFormContentDialog,
} from 'components';
import { useTranslation } from 'libs/i18n';
import { FormFooter } from 'modules/settings/common/components';
import { SettingsView } from 'modules/settings/common/views';

import {
  PasswordSettings,
  PasswordSettingsForm,
  PasswordSettingsFormProps,
} from '../components';
import { ChangePasswordFormType } from '../forms/changePasswordForm';

export interface PasswordSettingsViewProps extends PasswordSettingsFormProps {
  loading?: boolean;
  submitLoading?: boolean;
  isOpenVerificationDialog: boolean;
  onCloseVerificationDialog?: () => void;
}

export const PasswordSettingsView: FC<PasswordSettingsViewProps> = ({
  loading,
  passwordValidation,
  submitLoading,
  isOpenVerificationDialog,
  onCloseVerificationDialog,
  ...formProps
}) => {
  const { t } = useTranslation();
  return (
    <SettingsView tabValue="password">
      <LoadingLayoutWrapper loading={loading}>
        <PasswordSettingsForm
          {...formProps}
          passwordValidation={passwordValidation}
        >
          <PasswordSettings passwordValidation={passwordValidation} />

          <VerificationCodeFormContentDialog<ChangePasswordFormType>
            codeFieldName="otpCode"
            isOpen={isOpenVerificationDialog}
            title={t('settings.password.verificationDialog.title')}
            onClose={onCloseVerificationDialog}
          />

          <FormFooter submitLoading={submitLoading} />
        </PasswordSettingsForm>
      </LoadingLayoutWrapper>
    </SettingsView>
  );
};
